// import { useMediaQuery, useTheme } from '@mui/material';
import { useEffect, useState } from 'react';
import useMeasure from 'react-use-measure';

type DeviceType = 'mobile' | 'tablet' | 'desktop';

export interface IDeviceTypeResult {
  isMobile: boolean;
  isTablet: boolean;
  isDesktop: boolean;
  deviceType: DeviceType;
  ref: (node: HTMLElement | null) => void;
  width: number;
}

export enum ProductItemsBasedOnDevice {
  mobile = 4,
  tablet = 6,
  desktop = 8,
}
export const VERTICAL_LIST_COUNT = 10;

export const useDeviceType = (): IDeviceTypeResult => {
  const [ref, bounds] = useMeasure();

  const [deviceType, setDeviceType] = useState<DeviceType>('desktop');

  useEffect(() => {
    const width = bounds.width;

    if (width < 600) {
      setDeviceType('mobile');
    } else if (width < 900) {
      setDeviceType('tablet');
    } else {
      setDeviceType('desktop');
    }
  }, [bounds.width]);

  return {
    isMobile: deviceType === 'mobile',
    isTablet: deviceType === 'tablet',
    isDesktop: deviceType === 'desktop',
    deviceType,
    ref,
    width: bounds.width,
  };
};
